import React, { Component } from "react";
import { Icon, Select, Spin } from "antd";
import Parser from "html-react-parser";
import { urlPath } from "./Settings";
import { getAuthHeader } from "../utils/security";

const Option = Select.Option;
let versions = [];

/*eslint no-unused-vars: "off"*/
class History extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  setHistoryItems = () => {
    const historyItems = document.getElementsByClassName(
      "history-item-content"
    );
    const historyFrames = document.getElementsByClassName("history-frame");
    const historyLinks = document.getElementsByClassName("toggle-report");
    for (let i = 0; i < historyFrames.length; i++) {
      historyFrames[i].setAttribute("src", "");
      historyItems[i].classList.remove("visible");
      if (historyLinks[i]) historyLinks[i].innerHTML = "More...";
    }
  };
  componentDidMount() {
    this.loadAudits(this.props.matspecid, this.props.admaterial, 0);
    this.setHistoryItems();
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.admaterialId !== nextProps.admaterialId)
      this.loadAudits(this.props.matspecid, this.props.admaterial, 0);
    this.setHistoryItems();
  }

  /*  setVersions = number => {
    versions = [];
    for (let i = number; i > 0; i--) {
      versions.push(
        <Option key={i} value={i}>
          {i}
        </Option>
      );
    }
  }; */
  setVersions = audits => {
    console.log(audits);
    let ver = audits.map(audit => {
      console.log(audit.mainobjectversion);
      return audit.mainobjectversion;
    });
    ver = new Set(ver);
    ver = [...ver];
    ver = ver.sort((a, b) => b - a);
    console.log(ver)
    versions = ver.map(item => (
      <Option key={item} value={item}>
        {item}
      </Option>
    ));
    if (!this.state.versions) this.setState({ versions });
    console.log(versions);
  };

  toggleReport = e => {
    const element = e.target;
    const visible = element.innerHTML.includes("More");
    if (visible) {
      element.innerHTML = "Less...";
      element.closest(".history-item-content").classList.add("visible");
    } else {
      element.innerHTML = "More...";
      element.closest(".history-item-content").classList.remove("visible");
    }
    e.preventDefault();
    e.stopPropagation();
    return visible;
  };

  setFrameHeight = iframe => {
    iframe.height = "";
    iframe.height = iframe.contentWindow.document.body.scrollHeight + "px";
  };

  reportIframeLoaded = (id, type) => {
    const iFrameID = document.getElementById(id);
    setTimeout(function () {
      if (
        iFrameID &&
        iFrameID.contentWindow &&
        iFrameID.contentWindow.document.body
      ) {
        // here you can make the height, I delete it first, then I make it again
        iFrameID.height = "";
        iFrameID.height =
          iFrameID.contentWindow.document.body.scrollHeight + 50 + "px";
        if (type === "callas") {
          iFrameID.contentWindow.document.body.style.zoom = 0.58;
        }
      }
    }, 100);
  };

  getReport = (e, mainObject) => {
    const admaterialId = mainObject.replace("AdMaterial.", "");
    console.log(e);
    console.log(admaterialId);
    const visible = this.toggleReport(e);
    if (visible) {
      fetch(urlPath + "/api/noauth/recreatefile?admaterial=" + admaterialId)
        .then(response => response.text())
        .then(data => {
          console.log(data);
          const url = data;
          const historyFrames = document.getElementsByClassName(
            "history-frame"
          );
          for (let i = 0; i < historyFrames.length; i++) {
            if (historyFrames[i].getAttribute("data-id") === mainObject) {
              historyFrames[i].setAttribute("src", url);
              historyFrames[i].setAttribute(
                "id",
                "historyFrame." + mainObject + "." + i
              );
              this.reportIframeLoaded(historyFrames[i].getAttribute("id"));
            }
          }
        })
        .catch(e => console.error("Cannot load Report", e));
    }
    e.preventDefault();
    e.stopPropagation();
  };
  getCallasReport = (e, currentAudit, mainObject) => {
    const visible = this.toggleReport(e);
    if (visible) {
      for (let i = 0; i < currentAudit.audits.length; i++) {
        if (
          currentAudit.audits[i].file &&
          currentAudit.audits[i].file.includes(".html")
        ) {
          const url = currentAudit.audits[i].file;
          const historyFrames = document.getElementsByClassName(
            "history-frame"
          );
          for (let z = 0; z < historyFrames.length; z++) {
            if (historyFrames[z].getAttribute("data-id") === mainObject) {
              historyFrames[z].setAttribute("src", url);
              this.reportIframeLoaded(
                historyFrames[z].getAttribute("id"),
                "callas"
              );
              document
                .getElementById(
                  "reportLink." + historyFrames[z].getAttribute("id")
                )
                .setAttribute("href", url);
            }
          }
        }
      }
    }
    e.preventDefault();
    e.stopPropagation();
  };
  openCallasReport = (e, currentAudit, mainObject) => {
    for (let i = 0; i < currentAudit.audits.length; i++) {
      if (currentAudit.audits[i].file.includes(".html")) {
        const url = currentAudit.audits[i].file;
        const historyFrames = document.getElementsByClassName("history-frame");
        for (let z = 0; z < historyFrames.length; z++) {
          if (historyFrames[z].getAttribute("data-id") === mainObject) {
            historyFrames[z].setAttribute("src", url);
            this.reportIframeLoaded(
              historyFrames[z].getAttribute("id"),
              "callas"
            );
            document
              .getElementById(
                "reportLink." + historyFrames[z].getAttribute("id")
              )
              .setAttribute("href", url);
          }
        }
      }
    }
  };
  getXmlReport = (e, currentAudit, mainObject) => {
    const filePath = currentAudit.audits[0].file;
    const visible = this.toggleReport(e);
    if (visible) {
      const url = filePath; //change THIS WHEN PRODUCTION (only data )
      const historyFrames = document.getElementsByClassName("history-frame");
      for (let i = 0; i < historyFrames.length; i++) {
        if (historyFrames[i].getAttribute("data-id") === mainObject) {
          historyFrames[i].setAttribute("src", url);
          historyFrames[i].setAttribute("data-xml", true);
          this.reportIframeLoaded(historyFrames[i].getAttribute("id"));
        }
      }
    }
    e.preventDefault();
    e.stopPropagation();
  };

  loadAudits = async (matspec, admaterial, version) => {
    console.log("loadAudits running");
    const { printed } = this.props;
    this.setState({ loadingAudits: true });
    let loadAuditUrl = null;
    if (matspec) {
      loadAuditUrl = urlPath + "/api/loadaudits?&matspec=" + matspec;
      if (!printed && admaterial && parseInt(admaterial, 10) > 0)
        loadAuditUrl = loadAuditUrl + "&admaterial=" + admaterial;
      if (printed && version)
        loadAuditUrl = loadAuditUrl + "&version=" + version;
    }
    if (!matspec && admaterial && parseInt(admaterial, 10) > 0) {
      loadAuditUrl = urlPath + "/api/loadaudits/admaterial?id=" + admaterial;
    }
    let matspecAudits = this.state.matspecAudits || []
    if (matspec || admaterial) {
      if (!this.state.matspecAudits && this.props.printed) {
        const response = await fetch(
          loadAuditUrl +
          "&timezone=" +
          Intl.DateTimeFormat().resolvedOptions().timeZone,
          { credentials: "include", headers: getAuthHeader() }
        );
        matspecAudits = await response.json();
        this.setState({ matspecAudits });
      }
      fetch(
        loadAuditUrl +
        "&timezone=" +
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        { credentials: "include", headers: getAuthHeader() }
      )
        .then(response => response.json())
        .then(audits => {
          this.setState({ loadingAudits: false });
          if (audits.length > 0) {
            this.setState({ auditVersions: audits[0].mainobjectversion });
            const historyItems = [];
            this.setVersions(matspecAudits);
            //if (version === 0) this.setVersions(audits[0].mainobjectversion);
            for (let i = 0; i < audits.length; i++) {
              const currentAudit = audits[i];
              let currentAuditDate = currentAudit.time.split(" ")[0];

              let currentAuditTime = currentAudit.time.split(" ")[1];
              if (currentAudit.time.split(" ").length > 2) {
                const currentAuditAmPm = currentAudit.time.split(" ")[2].toLowerCase();
                if (currentAuditAmPm.includes("am") || currentAuditAmPm.includes("pm")) {
                  console.log("AUDIT TIME--------", currentAudit);
                  currentAuditTime += " " + currentAuditAmPm.toUpperCase();
                }
              }

              currentAuditDate = currentAuditDate
                .replace(".", "/")
                .replace(".", "/");

              const mainObject = currentAudit.object_main;
              //if(currentAudit.object_main.includes(admaterial))
              /*eslint jsx-a11y/href-no-hash: "off"*/
              historyItems.push(
                <div key={i} className="history-item">
                  <div className="history-item-left">
                    <span className="history-item-dot" />
                    <p className="audit-datetime">
                      <span className="audit-date">{currentAuditDate}</span>
                      <span className="audit-time">{currentAuditTime}</span>
                    </p>
                    <p className="audit-user">{currentAudit.user.name}</p>
                  </div>
                  <div className="history-item-right">
                    <div className="history-item-header">
                      <div className="history-item-title">
                        {currentAudit.source.name &&
                          currentAudit.source.name.length > 0
                          ? currentAudit.source.name
                          : currentAudit.source}
                      </div>
                      <div
                        className="history-item-status"
                        style={{
                          width: "250px",
                          border: "1px solid " + currentAudit.status.color,
                          background: currentAudit.status.color + "50"
                        }}
                      >
                        {currentAudit.status.text}
                      </div>
                    </div>
                    <div className="history-item-content">
                      {currentAudit.audits[0] &&
                        currentAudit.audits[0].lazyfile ? (
                          <div>
                            <a
                              href="#"
                              className="toggle-report"
                              onClick={e => this.getReport(e, mainObject)}
                            >
                              More...
                          </a>
                            <iframe
                              onLoad={this.reportIframeLoaded(currentAudit.id)}
                              id={currentAudit.id}
                              className="history-frame"
                              data-id={mainObject}
                              title="report"
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      {currentAudit.audits[0] &&
                        currentAudit.audits[0].file &&
                        currentAudit.audits[0].file.includes("booking") ? (
                          <div>
                            <a
                              href={currentAudit.audits[0].file}
                              target="_blank"
                              className=""
                            >
                              {this.props.translations.openReport}
                            </a>
                            <iframe
                              className="d-none"
                              onLoad={this.reportIframeLoaded(currentAudit.id)}
                              id={currentAudit.id}
                              className="history-frame"
                              data-id={mainObject}
                              title="xmlReport"
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      {currentAudit.audits[0] &&
                        currentAudit.audits[0].file &&
                        !currentAudit.audits[0].file.includes("booking") ? (
                          <div>
                            <a
                              href="#"
                              className="toggle-report"
                              onClick={e =>
                                this.getCallasReport(e, currentAudit, mainObject)
                              }
                            >
                              More...
                          </a>
                            <a
                              href="#"
                              target="_blank"
                              className="open-report"
                              id={"reportLink." + currentAudit.id}
                              onClick={e =>
                                this.openCallasReport(e, currentAudit, mainObject)
                              }
                            >
                              <Icon type="select" />
                            </a>
                            <iframe
                              onLoad={this.reportIframeLoaded(currentAudit.id)}
                              id={currentAudit.id}
                              className="history-frame"
                              data-id={mainObject}
                              title="callasReport"
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      {currentAudit.audits[0] &&
                        currentAudit.audits[0].oldvalue ? (
                          <div>
                            <span style={{ fontWeight: 700 }}>
                              {currentAudit.audits[0].translation}:{" "}
                            </span>
                            <span>{currentAudit.audits[0].oldvalue}</span>
                            <span> to </span>
                            <span>{currentAudit.audits[0].value}</span>
                          </div>
                        ) : (
                          ""
                        )}
                      {currentAudit.audits[0] && currentAudit.audits[0].value && (
                        <p className="audit-value">
                          <span data-translationkey="value" className="bold">
                            {this.props.translations.value}:{" "}
                          </span>
                          {currentAudit.audits[0].value}
                        </p>
                      )}
                      {currentAudit.audits[0] &&
                        currentAudit.audits[0].type === "EmailAuditLog" && (
                          <div>
                            <a
                              href="#"
                              className="toggle-report"
                              onClick={e => this.toggleReport(e)}
                            >
                              More...
                            </a>
                            <div className="email-audit">
                              <span style={{ display: "block" }}>
                                <span style={{ fontWeight: "bold" }}>
                                  from:
                                </span>
                                {currentAudit.audits[0].from}
                              </span>
                              <span style={{ display: "block" }}>
                                <span style={{ fontWeight: "bold" }}>to:</span>{" "}
                                {currentAudit.audits[0].to}
                              </span>
                              <span style={{ display: "block" }}>
                                <span style={{ fontWeight: "bold" }}>
                                  subject:
                                </span>
                                {currentAudit.audits[0].subject}
                              </span>
                              <span>{Parser(currentAudit.audits[0].body)}</span>
                            </div>
                          </div>
                        )}
                    </div>
                    <hr />
                  </div>
                </div>
              );
            }
            this.setState({ historyItems: historyItems });
          } else this.setState({ historyItems: [] });
        })
        .catch(e => {
          console.error("Cannot load audits", e);
          this.setState({ loadingAudits: false });
        });
    } else {
      console.error("Cannot retrieve audits for no matspec");
    }
  };

  handleChange = value => {
    console.log(value);
    this.setState({ auditVersions: value });
    this.loadAudits(this.props.matspecid, this.props.admaterial, value);
  };

  render() {
    const { historyItems } = this.state;
    if (this.state.loadingAudits) return <Spin style={{ display: "block" }} />;
    return (
      <div>
        <div id="auditVersionContainer">
          {this.props.printed && (
            <div>
              <label>Version</label>
              <Select
                size="small"
                className="version-top"
                value={this.state.auditVersions}
                onChange={val => this.handleChange(val)}
              >
                {this.state.versions}
              </Select>
            </div>
          )}
        </div>
        <section
          id="historyTab"
          className="history-tab"
          style={{
            height: "calc(80vh / " + this.props.bodyZoom + ")"
          }}
        >
          {historyItems && historyItems.length > 0
            ? this.state.historyItems
            : "No data"}
        </section>
      </div>
    );
  }
}

export default History;



// WEBPACK FOOTER //
// ./src/components/History.js